import {
  Button,
  Divider,
  Image,
  message,
  Pagination,
  Popconfirm,
  Table,
  Tag,
} from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, FormOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { deleteCasino, getCasino } from "./CasinoAPI";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../Utils";

function Casino() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPages] = useState();
  const [offerData, setOfferData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  function FetchOfferData() {
    setIsLoading(true);
    getCasino(
      `?limit=10&page=${currentPage}${
        search && search.length ? `&search=${search}` : ""
      }`
    )
      .then((response) => {
        if (response.status) {
          setIsLoading(false);
          setOfferData(response.data.items);
          setTotalPages(response?.data?.pagination?.lastPage);
          setCurrentPage(response?.data?.pagination?.currentPage);
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchOfferData();
  }, [currentPage]);
  function DeleteAction(checked, record) {
    deleteCasino(`${record._id}`)
      .then((response) => {
        if (response.status) {
          message.open(messageConfiguration("success", response.message, 3));
          FetchOfferData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const columns = [
    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
      className: "custom-header font-dmsans text-sm ",
      render: (data, record) => {
        return (
          <Image
            src={record.image}
            // height={100}
            // width={188}
            preview={false}
            className="rounded-md  "
            style={{ boxShadow: "0px 0px 15px #e5e5e5" }}
          />
        );
      },
    },
    {
      title: "Page Number",
      dataIndex: "pageNumber",
      key: "pageNumber",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record.pageNumber}
        </p>
      ),
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      className: "font-dmsans text-sm text-white",
      render: (link) => (
        <div className="text-xs font-dmsans break-all whitespace-normal">
          <a href={link} target="_blank" rel="noopener noreferrer">
            {link}
          </a>
        </div>
      ),
      width: 300,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      align: "center",
      className: "font-dmsans text-sm",
      render: (data) => {
        return (
          <div className="flex justify-center">
            <Tag
              className={`text-xs font-dmsans items-center flex justify-center ${
                data
                  ? "bg-[#996600] text-white border-none p-1 w-[80px]"
                  : "bg-[#cecdcd] text-white border-none p-1 w-[80px]"
              }`}
            >
              {data ? "Active" : "Inactive"}
            </Tag>
          </div>
        );
      },
    },
    {
      title: "Created Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
        </p>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <div className="items-center flex justify-center ">
          <FormOutlined
            title="Edit"
            className=" font-bold cursor-pointer text-lg text-[#616161] h-[18px] w-4"
            onClick={() =>
              navigate("/casino/add_casino", {
                state: {
                  fill: record,
                  from: "edit",
                },
              })
            }
          />
        </div>
      ),
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "font-dmsans text-sm",
      render: (data, record) => (
        <div className="items-center flex justify-center ">
          <Popconfirm
            title={
              <div>
                <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                  Are you sure you want to delete this Casino?
                </p>
              </div>
            }
            onConfirm={() => DeleteAction(undefined, record)}
            okText="Delete"
            cancelText="Cancel"
          >
            <DeleteOutlined className="text-xs font-dmsans" title="Delete" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="ml-2  mt-6 mr-2">
        <div className=" mb-8 ">
          <Divider
            orientation="left"
            style={{ border: "#cecece" }}
            className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
          >
            Casino Details
          </Divider>
          <div className="flex justify-end items-end gap-3">
            <div>
              <Button
                onClick={() =>
                  navigate("/casino/add_casino", {
                    state: {
                      fill: null,
                      from: "add",
                    },
                  })
                }
              >
                Add Casino
              </Button>
            </div>
          </div>
        </div>

        <div
          style={{ maxHeight: "620px", overflow: "auto" }}
          className="bg-white"
        >
          <Table
            columns={columns}
            dataSource={offerData}
            className="w-screen sm:w-screen"
            loading={isLoading}
            pagination={false}
          />
        </div>
        <Pagination
          className="mt-2  flex justify-center items-center font-inter font-medium text-base w-full  h-[19px] "
          onChange={handlePageChange}
          current={currentPage}
          defaultCurrent={1}
          total={10 * totalPage}
          showSizeChanger={false}
        />
      </div>
    </>
  );
}
export default Casino;
